module.exports = __webpack_public_path__ + "verified-buyer.svg?43d235cfb2ca588e5d47271e3201b174";